import { createFeatureSelector, createSelector } from '@ngrx/store';
import { SenderListState, SENDER_LIST_STATE } from './sender-list.state';

export const selectSender =
  createFeatureSelector<SenderListState>(SENDER_LIST_STATE);

export const selectSenderList = createSelector(
  selectSender,
  (state: SenderListState) => {
    return state.dataSource;
  }
);

export const selectSenderListFilter = createSelector(
  selectSender,
  (state: SenderListState) => state.filter
);
